import { dew as _abiDew } from "../../errors/abi.js";
import { dew as _sliceDew } from "../data/slice.js";
import { dew as _getFunctionSelectorDew } from "../hash/getFunctionSelector.js";
import { dew as _decodeAbiParametersDew } from "./decodeAbiParameters.js";
import { dew as _formatAbiItemDew } from "./formatAbiItem.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.decodeFunctionData = void 0;
  const abi_js_1 = _abiDew();
  const slice_js_1 = _sliceDew();
  const getFunctionSelector_js_1 = _getFunctionSelectorDew();
  const decodeAbiParameters_js_1 = _decodeAbiParametersDew();
  const formatAbiItem_js_1 = _formatAbiItemDew();
  function decodeFunctionData({
    abi,
    data
  }) {
    const signature = (0, slice_js_1.slice)(data, 0, 4);
    const description = abi.find(x => x.type === "function" && signature === (0, getFunctionSelector_js_1.getFunctionSelector)((0, formatAbiItem_js_1.formatAbiItem)(x)));
    if (!description) throw new abi_js_1.AbiFunctionSignatureNotFoundError(signature, {
      docsPath: "/docs/contract/decodeFunctionData"
    });
    return {
      functionName: description.name,
      args: "inputs" in description && description.inputs && description.inputs.length > 0 ? (0, decodeAbiParameters_js_1.decodeAbiParameters)(description.inputs, (0, slice_js_1.slice)(data, 4)) : undefined
    };
  }
  exports.decodeFunctionData = decodeFunctionData;
  //# sourceMappingURL=decodeFunctionData.js.map
  return exports;
}